import React from 'react'
import { observer } from 'mobx-react'
import GlobalStore from '../Stores/GlobalStore'
import { DeviceDeactivatedScreen } from './DeviceDeactivatedScreen'

export const DeviceGate = observer(({ children }: { children: React.ReactNode }) =>
  GlobalStore.deviceRevoked ? <DeviceDeactivatedScreen /> : <>{children}</>
)
